import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 48px 20px;
  text-align: center;
  color: ${({ theme }) => theme.colors.textMuted};
`;

const Title = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.heading};
`;

/** Пустой список / ошибка загрузки — вместо молчаливого белого экрана. */
export function StatusMessage({ title, description, children }) {
  return (
    <Wrapper role="status">
      {title && <Title>{title}</Title>}
      {description && <p>{description}</p>}
      {children}
    </Wrapper>
  );
}

export default StatusMessage;
